/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DriverVoResourceService} from './delivery/driver-vo-resource.service';
import {VehicleVoResourceService} from './delivery/vehicle-vo-resource.service';
import {DeliveryServiceVoResourceService} from './delivery/delivery-service-vo-resource.service';
import {EmployeeVoResourceService} from './delivery/employee-vo-resource.service';
import {AccountVoResourceService} from './delivery/account-vo-resource.service';
import {AgentZoneVoResourceService} from './delivery/agent-zone-vo-resource.service';
import {DeliveryServiceProviderResourceService} from './delivery/delivery-service-provider-resource.service';
import {DelTerritoryVoResourceService} from './delivery/del-territory-vo-resource.service';
import {CustomerContactsDropdownResourceService} from './crm/customer/customer-contacts-dropdown-resource.service';
import { CountryVoResourceService } from '@well/common-libs/country-management/shell-api';
import { SelectableResourceService } from '@well/common-libs/selectable-resource-management/util';
import { etransportSelectableResourceProviders } from '@well/delivery-libs/etransport/data-access';
import { costCenterSelectableResourceProviders } from '@well/delivery-libs/cost-center/resource-services';
import {
  unitMeasurementSelectableResourceProviders
} from '@well/common-libs/unit-measurement/data-access';
import { dispatcherSelectableResourceProviders } from '@well/delivery-libs/dispatcher/resource-services';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: SelectableResourceService,
      useClass: DriverVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: CustomerContactsDropdownResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: VehicleVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: DeliveryServiceVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: EmployeeVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: AccountVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: AgentZoneVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: CountryVoResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: DeliveryServiceProviderResourceService,
      multi: true
    },
    {
      provide: SelectableResourceService,
      useClass: DelTerritoryVoResourceService,
      multi: true
    },
    ...costCenterSelectableResourceProviders,
    ...etransportSelectableResourceProviders,
    ...unitMeasurementSelectableResourceProviders,
    ...dispatcherSelectableResourceProviders
  ]
})
export class ResourceServicesModule {
}
